// extracted by mini-css-extract-plugin
module.exports = {"container":"CallUs-module__container___Ryd-r","content":"CallUs-module__content___4uyZh","text":"CallUs-module__text___mYpwR","number":"CallUs-module__number___q8io-"};